import(/* webpackMode: "eager", webpackExports: ["CombatOperationsFeed"] */ "/var/www/light_of_empire_front/widgets/CombatOperationsFeed/CombatOperationsFeed.tsx");
